var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { TextBodyDEPRECATED } from '../../TypographyDEPRECATED';
import { get } from '../../tools/utils';
var StyledTextBody = styled(TextBodyDEPRECATED)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: center;\n\n  ", "\n"], ["\n  text-align: center;\n\n  ", "\n"])), function (props) {
    return !props.isCaptionVisible ? get.screenReader('srOnly')(props) : '';
});
var Caption = function (_a) {
    var captionText = _a.captionText, isCaptionVisible = _a.isCaptionVisible, tableId = _a.tableId;
    return (React.createElement(StyledTextBody, { id: tableId, tag: "p", size: "sm", isCaptionVisible: isCaptionVisible }, captionText));
};
export default Caption;
var templateObject_1;
//# sourceMappingURL=Caption.js.map